"use strict";

function CompanyFeedActivityTranslator() {
  var types = {
    MESSAGE: function(f) {
      return {
        text: f.content,
        createdAt:  f.createdAt,
        type:       "message",
        user:       f.createdBy,
        object: {
          id: f.id,
          name: f.title,
          type: 'MESSAGE'

        },
        groups: f.groups,
        id: f.id,
        extra: f.extra
      };
    },
    COMMENT: function(c) {
      return {
        text: c.text,
        createdAt: c.createdAt,
        type:      "comment",
        user:      c.createdBy,
        object: c.objectRelative
      };
    }
  };

  return function(item) {
    if(types.hasOwnProperty(item.activityType)) {
      return types[item.activityType](item);
    }
    return false;
  };
}

angular.module("dokiv")
  .factory("CompanyFeedActivityTranslator", [CompanyFeedActivityTranslator]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyFeedActivityTranslator.js
// module id = 324
// module chunks = 0